// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"222":"41f804bf","418":"4238b8db","7937":"e9f65214","8214":"41f804bf","9322":"e9f65214"}[chunkId] + ".chunk.css";
};